// TODO: There has to be a better way
export const nonBrowserFeatureState = /electron/i.test(navigator.userAgent);
